import axios from 'axios';

const BASE_URL = 'https://inventariosbackend.velasresorts.com/inventarios/modulos';

const modulosApi = {
    listado: async () => {
        try {
            const response = await axios.get(`${BASE_URL}/listado`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            if (Array.isArray(response.data) && Array.isArray(response.data[0])) return response.data[0];
            return Array.isArray(response.data) ? response.data : (response.data?.data || []);
        } catch (error) {
            console.error('Error fetching módulos:', error);
            return [];
        }
    },

    crearUsuarioModulo: async (data: { UsuarioId: number | string; ModuloId: number | string; CreatedDate: string; LastModifiedDate: string }) => {
        const response = await axios.post(
            `https://inventariosbackend.velasresorts.com/inventarios/usuariosmodulos/crear`,
            data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            }
        );
        return response.data;
    },

    listadoUsuariosModulos: async () => {
        try {
            const response = await axios.get(`https://inventariosbackend.velasresorts.com/inventarios/usuariosmodulos/listado`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            if (Array.isArray(response.data) && Array.isArray(response.data[0])) return response.data[0];
            return Array.isArray(response.data) ? response.data : (response.data?.data || []);
        } catch (error) {
            console.error('Error fetching usuarios-módulos:', error);
            return [];
        }
    },

    darBajaUsuarioModulo: async (id: number | string) => {
        const response = await axios.put(
            `https://inventariosbackend.velasresorts.com/inventarios/usuariosmodulos/baja/${id}`,
            {},
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            }
        );
        return response.data;
    }
};

export default modulosApi;
